export default "__VITE_ASSET__hpaKsnfM__"